import { useState, useEffect } from "react";
import { Button, Circle } from "@chakra-ui/react";
import { useColorModeValue } from "../components/ui/color-mode";

const StatusSign = () => {
    const [serviceStatus, setServiceStatus] = useState("checking");
    const statusUrl = "https://api.labchron.app";
    const statusPage = "https://www.labchron.app";

    const onlineColor = useColorModeValue("green.300", "green.300");
    const offlineColor = useColorModeValue("red.600", "red.300");
    const onlineBorder = useColorModeValue("green.400", "green.400");
    const offlineBorder = useColorModeValue("red.500", "red.400");
    const onlineDot = useColorModeValue("green.400", "green.400");
    const offlineDot = useColorModeValue("red.400", "red.400");
    const onlineHover = useColorModeValue("green.400/50", "green.400/50");
    const offlineHover = useColorModeValue("red.400/50", "red.400/50");

    useEffect(() => {
        const checkStatus = async () => {
            try {
                const response = await fetch(statusUrl + '/status');
                if (response.ok) {
                    setServiceStatus("online");
                } else {
                    setServiceStatus("offline");
                }
            } catch (error) {
                console.error(error);
                setServiceStatus("offline");
            }
        };

        checkStatus();
        const interval = setInterval(checkStatus, 300000);
        return () => clearInterval(interval);
    }, []);

    const handleClick = () => {
        window.open(statusPage, "_blank");
    };

    const isOnline = serviceStatus === "online";
    const dotColor = isOnline ? onlineDot : offlineDot;
    const label = isOnline ? "online" : "offline";

    return (
        <Button
            variant="outline"
            size="sm"
            px={3}
            onClick={handleClick}
            loading={serviceStatus === "checking"}
            loadingText="Checking"
            borderColor={isOnline ? onlineBorder : offlineBorder}
            color={isOnline ? onlineColor : offlineColor}
            _hover={{
                bg: isOnline ? onlineHover : offlineHover,
            }}
        >
            <Circle size="2" bg={dotColor} />
            Console {label}
        </Button>
    );
};

export default StatusSign;
